<template>
  <div>
    <div class="row mb-2">
      <div class="col-auto mr-auto">
        <h3 v-html="$t('categories.edit', [currentCategory.name])" />
      </div>
    </div>

    <CategoryForm
      :id="$route.params.id"
      :category="currentCategory"
      @categorySubmitted="saveCategory"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { ROUTE_CATEGORY_DETAIL } from "../../constants";
import CategoryForm from "./CategoryForm";

export default {
  name: "CategoryEdit",
  components: { CategoryForm },
  computed: {
    ...mapGetters(["categoryById"]),
    currentCategory() {
      return this.categoryById(this.$route.params.id);
    }
  },
  methods: {
    saveCategory(payload) {
      this.$router.push({
        name: ROUTE_CATEGORY_DETAIL,
        params: { id: payload.id, name: payload.category.name }
      });
    }
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit("changeBg");
    next();
  }
};
</script>

<style scoped></style>
